define('responsive-gameday/views/Monitor/ViewModels/distributors/MatchupViewDistributor',['require','exports','module','jquery','message-service/message-service','../../Events/SceneStateEvents','../../Events/ViewModelUpdateEvents','GameDayCore/GDModel/enums/datasources/Datasources','GameDayCore/GDUtil/dataMapping/NumberWithOrdinal','gameday-index-enums/enums/baseball/GameStates','gameday-resource-path/gameday-resource-path','GameDayCore','extant/extant','../../../../utils/ui-log'],function(require,exports,module) {

    var $ = require("jquery"),
        MessageService = require("message-service/message-service"),
        SceneStateEvents = require("../../Events/SceneStateEvents"),
        UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        NumberWithOrdinal = require("GameDayCore/GDUtil/dataMapping/NumberWithOrdinal"),
        GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        GDC = require("GameDayCore"),
        exists = require("extant/extant"),
        uilog = require( '../../../../utils/ui-log');

    var gameData,
        stateUpdates,
        linescore,
        plays,
        dataPack;


    exports.setGameData = function(game, scenes) {
        gameData = $.extend({}, game);
        plays = gameData.play;
        stateUpdates = scenes;

        linescore = gameData.linescore;
        buildSendDataPack();
        MessageService.off(UpdateEvents.REQUEST_MATCHUP_DATA,this.handleUpdateRequest);
        MessageService.on(UpdateEvents.REQUEST_MATCHUP_DATA,this.handleUpdateRequest);

    };

    exports.handleUpdateRequest = function() {
        gameData = GDC.getGameData();
        buildSendDataPack();
        // MessageService.publish(UpdateEvents.UPDATE_MATCHUP, dataPack);
    };

    function getInningState(plays,linescore){
        var innState;
        if (plays.abstractGameState === GameStates.ABSTRACT_DELAYED && linescore.gamestate.indexOf("Delay")!==-1) {
            innState = "Delay";
        } else if (plays.abstractGameState === GameStates.ABSTRACT_OTHER) {
            innState=plays.gamestate + ': '+ plays.reason;
        } else {
            innState = (plays.inning_state !== "") ? plays.inning_state.substr(0,3) + " " + NumberWithOrdinal(plays.inning) : plays.gamestate;
        }

        return innState;
    }
    function getSecondLine(plays,dataPack){
        if(dataPack.matchup.showSecondLineOnInningStatus){
            if(dataPack.resumeDate){
                return 'Resumes on ' + dataPack.resumeDate;
            }else if(plays.reason){
                return plays.reason;
            }else if(dataPack.matchup.firstPitch){
                return "1st Pitch " + dataPack.matchup.firstPitch+" ET"
            }
        }
        return null;
    }


    exports.buildData = function(_gameData){
        gameData = _gameData || gameData;
        var batter,
            pitcher,
            balls,
            strikes,
            outs;

        var dataPack = { };
        linescore = linescore || _gameData.linescore;
        plays = gameData.play;
        dataPack.inningState = plays.half_inning;
        if(linescore.resume_date){
            dataPack.resumeDate = linescore.resume_date.substr(linescore.resume_date.indexOf('/') + 1);
        }
        if(plays.gamestate === "Pre-Game" ||  plays.gamestate === "Warmup") {
            dataPack.firstPitch = gameData.game.game_time_et;
        } else {
            dataPack.firstPitch = null;
        }

        if (exists(gameData, "play.atbat")) {
            dataPack.atbat = plays.atbat;
            dataPack.pitches = plays.atbat.pitches;

            batter  = plays.atbat.getBatterModel();
            pitcher = plays.atbat.getPitcherModel();
            balls   = plays.atbat.b;
            strikes = plays.atbat.s;
            outs    = plays.atbat.o;

        } else if (plays.batter && plays.pitcher) {
            uilog.log("there was no atbat present in the plays file. Fill in from other sources");

           /*
            * atBat file not there, build player info from players and 
            * boxscore file. This usually happens during coachting vists
            * to the mound and picher changes.
            */

            var playerData = GDC.getGameData("players,boxscore"),
              currentBatter = playerData.players.playerMap[plays.batter.pid],
              currentPitcher = playerData.players.playerMap[plays.pitcher.pid],
              currentBatterBoxData = playerData.boxscore.findPlayer(plays.batter.pid, "b"),
              currentPitcherBoxData = playerData.boxscore.findPlayer(plays.pitcher.pid, "p");

            batter = {
                pid: plays.batter.pid,
                boxname:  currentBatter.last,
                mugshot: resourcePath.get('mugshot',{ pid : plays.batter.pid}),
                num: currentBatter.num,
                pos: currentBatter.position,
                h: currentBatterBoxData.h,
                ab: currentBatterBoxData.ab,
                avg: currentBatter.avg,
                hrs: currentBatter.hr,
                rbis: currentBatter.rbi
            };

            pitcher = {
                pid: plays.pitcher.pid,
                boxname:  currentPitcher.last,
                mugshot: resourcePath.get('mugshot',{ pid : plays.pitcher.pid}),
                num: currentPitcher.num,
                rl: currentPitcher.rl,
                era: currentPitcher.era,
                pitches: currentPitcherBoxData.np,
                strikes: currentPitcherBoxData.s,
                balls: currentPitcherBoxData.np - currentPitcherBoxData.s
            };

            balls = plays.balls;
            strikes = plays.strikes;
            outs = plays.outs;

        }

        if (exists(gameData, "play.atbat") || (plays.batter && plays.pitcher)) {
            /*
             * Mashup of data responsible for showing current pitcher
             * batter matchup.
             */
            dataPack.matchup = {
                batter : batter,
                pitcher: pitcher,
                awayTeamId: 't'+ gameData.game.away.id,
                homeTeamId: 't'+ gameData.game.home.id,
                homeScore: gameData.boxscore.home_runs,
                awayScore: gameData.boxscore.away_runs,
                homeName: gameData.game.home.name_brief,
                awayName: gameData.game.away.name_brief,
                battingTeamAbbrev: plays.batter.team_abbrev,
                inningsState: getInningState(plays,linescore),
                balls: balls,
                strikes: strikes,
                outs: outs,     
                showSecondLineOnInningStatus: plays.reason || plays.inning_state === 'Top' || 
                                        plays.inning_state === 'Bottom' ||
                                        linescore.resume_date != null ||
                                        dataPack.firstPitch != null
            };
            dataPack.matchup.secondLine = getSecondLine(plays,dataPack);
        } 
        return dataPack;      
    }


    function buildSendDataPack() {
        dataPack = exports.buildData();

        MessageService.publish(UpdateEvents.UPDATE_MATCHUP, dataPack);
    }
});
